import { asMessages } from '@core/Utils/Intl/AsMessages';
export const scope = 'containers.financialCalculator';
const definition = asMessages(scope, {
  wantToPayMonthly: 'Want to pay monthly?',
  standardFinance: 'Standard Finance',
  privateLeasingFinance: 'Leasing Finance',
  threeWayFinance: '3 way Finance',
  intro:
    'Keep your options open, spread your payments with clear, flexible finance that suits you. Select one of the options below to calculate your contract length, deposit and repayments.',
  findOut: 'Find out how car finance works',
  introHeader: 'IntroHeader',
  calculationHeader: 'Finance options',
  submitToDealer: 'Submit to dealer',
  startUniversalJourney: 'Continuer',
  reservedVehicleLabel: 'Vehicle reserved',
  checkoutHeaderIntro: 'Your finance options',
  checkoutFindOut: 'What is the difference between PCP and HP?',
  emailSelf: 'Email self',
  additionalServices: 'Select your insurance and optional services: monthly cost',
  pdfAncorLink: "Télécharger le document d'information sur le produit d'assurance",
  subAdditionalServices: 'Je finance en crédit',
  totalMonthlyRate: 'Monthly Payments',
  monthPrefix: 'Month Prefix',
  porscheLeasing: 'porsche Leasing',
  subLeasingAmount: 'Leasing Amount',
  leasingAmount: 'Leasing Rate',
  totalMonthlyAsterik: '/month',
  totalMonthly: '/month',
  totalUniversalMonthlyAsterik: 'par mois',
  totalMonthlyCgi: 'par mois',
  annualInterestRate: 'Representative APR',
  nominalInterestRate: 'Interest Rate (Fixed)',
  totalVehiclePrice: 'Total Vehicle Price',
  oneTimePayment: 'One Time Payment',
  leasingDuration: 'Leasing Duration',
  totalUniversalVehiclePrice: "Montant total dû en cas d'acquisition du véhicule",
  taeg: 'TAEG',
  yearlyInterest: 'Yearly Interest',
  additionalContractHeader: 'Buche optionale Zusatzservices',
  additionalContractSubheader: 'Additional Contract Subheader',
  additionalContractPrefix: 'Porsche GAP',
  additionalContractHelpText: 'additionalContractHelpText',
  additionalContractDisclaimer: 'additionalContractDisclaimer',
  additionalContractDisclaimerTwo: 'additionalContractDisclaimer Two',
  additionalContractDisclaimerThree: 'additionalContractDisclaimer Three',
  additionalContractFooter: 'additionalContractFooter',
  additionalContractFooterTwo: 'additionalContractFooterTwo',
  additionalContractFooterList: 'additionalContractFooterList',
  additionalContractFooterListTwo: 'additionalContractFooterListTwo',
  additionalContract:
    ' Schließt den Differenzbetrag zwischen Abrechnungs- und Wiederbeschaffungswert bei Totalschaden oder Diebstahl',
  netLoanAmount: 'Net Loan',
  totalInterestAmount: 'Interest Amount',
  depositContribution: 'Deposit Contribution',
  lender: 'Lender',
  porscheSummaryTitle: 'Ein Finanzierungsbeispiel der Porsche Financial Services',
  mobilizeSummaryTitle: 'Ein Finanzierungsbeispiel der Mobilize Financial Services',
  lenderNote: 'Rates and lender may change when you apply for finance online',
  totalDeposit: 'Total Deposit',
  totalDepositVwfsFr: '1er loyer majoré',
  optionalFinalPayment: 'Optional Final Payment',
  retailCashPrice: 'Retail Cash Price',
  vehiclePrice: 'Total price',
  specialPayment: 'Special Payment',
  applicationCostFee: 'application fee',
  firstPayment: '1er Loyer majoré',
  optionalPayment: 'Optional Payment',
  subAmount: 'Sub Amount',
  cashDeposit: 'Deposit',
  months: 'Contract Length',
  monthsInput: 'Months',
  chargesForCredit: 'Total Charge For Credit',
  balance: 'Balance To Finance',
  totalAmountPayable: 'Total Amount Payable',
  totalLeasingMonthlyRate: 'Monthly Leasing Rate',
  finalPayment: 'Final Payment',
  monthSuffix: 'Rate',
  totalLeasingPrice: 'Total Leasing',
  mileage: 'Mileage Per Annum',
  excessMileagePerMile: 'Excess Mileage (per mile)',
  optionToPurchaseFee: 'Option to Purchase Fee',
  insuranceInfo: 'Insurance Info',
  totalAmountInsurance: 'total Insurance',
  totalSubInsurance: 'sub total Insurance',
  pcpFilm: 'Watch a film about PCP',
  pcpGuide: 'Read a full PCP guide',
  emailError: 'Enter a valid email',
  invalidField: 'This field is invalid',
  emailHeader: 'Enter your details to get a personal quote',
  emailCustomError: 'Something went wrong, please try again',
  hpFilm: 'Watch a film about HP',
  hpGuide: 'Read a full HP guide',
  emailPrivacy: 'By submitting, you agree to our',
  emailCta: 'Send quote',
  termsPolicy: ' privacy policy.',
  termsTitle: 'term title.',
  gdprHeader: 'Mention Protection des Données personnelles et Cookies pour le simulateur VIVAFI',
  gdprLink: 'Lire la mention protection des données personnelles',
  successMessage: 'Finance Quote has been sent to your email',
  paymentPlan: 'Payment plan',
  financeMonths: 'Months',
  financeMileage: 'Annual Mileage (PCP only)',
  financeMileageVwfsFr: 'Kilométrage annuel',
  financeDeposit: 'Deposit',
  financeDepositVwfsFr: '1er loyer majoré',
  financeTermLabel: 'Months',
  vehicleInsurance: 'Financière Automobile +',
  deathAndDisabilityInsurance: 'Décès - Incapacité',
  vehicleMaintenanceWarranty: "Garantie d'entretien du véhicule",
  vehiclePlatinumWarranty: 'extension de Garantie Platine',
  vehicleReplacementInsurance: 'VDR Tous risques VIP',
  porscheGap: 'Porsche GAP',
  deathDisabilityAndUnemploymentInsurance: 'Décès-Incapacité de travail',
  replacementVehicleElectric: 'Véhicule de Remplacement VIP (Electrique)',
  financialLossInsurance: 'Perte financière',
  financeMileageLabel: 'miles',
  totalPCP: 'Personal Contract Purchase',
  totalHP: 'Hire Purchase',
  PCP: 'PCP',
  HP: 'HP',
  universalVehiclePrice: 'Universal vehicle price',
  netLoanUniversalAmount: 'Net loan amount',
  financeModalHeader: "Let's talk finance",
  financeDealReview: 'Review and continue',
  financeDealClose: 'Close Details',
  financeDealPCP: 'Continue with',
  financeDealHP: 'Continue with HP',
  financePcpGuide: 'PCP text guide',
  financeHpGuide: 'HP text guide',
  financePcpVideo: 'PCP video guide',
  financeHpVideo: 'HP video guide',
  financeGuideIntro: 'Need more information on PCP or HP?',
  financeCalculatorError: "Sorry, we couldn't find any finance options for this vehicle",
  dealership:
    'Note: The dealership may offer other financing solutions as well. Contact them to learn more.',
  errorTitle: 'Oops! Looks like something is not working.',
  errorBody:
    'Finance is still available for this car, please try again later or speak to the dealer to find out more.',
  notAvailable: 'Not available',
  notAvailableMonth: 'month',
  notAvailableIntro: 'We are no able to give you a quote with the terms or deposit selected.',
  notAvailableMessage: 'Please try a lower deposit amount or choose a loan term between ',
  to: 'to',
  financePreApprvalCta: 'Remplire le formulaire',
  financePreApprovalTitle: 'Êtes-vous éligible pour ce prêt?',
  financePreApprovalSubTitle: 'Obtenez une réponse de principe immédiate',
  errorOverlayTitle: 'Oops! Looks like something is not working.',
  errorMessageDealer: 'Message Dealer',
  errorOverlayBody:
    'Finance is still available for this car, please try again later or speak to the dealer to find out more.',
  financePreApprovalError:
    'Le formulaire de réponse de principe immédiate n’est pas disponible pour le moment. Veuillez réessayer ultérieurement.',
  perMonth: 'par mois',
  closingOptions: 'Schlussoptionen',
  monthlyInstallments: 'Monatsraten',
  downPayment: 'Anzahlung',
} as const);

export const calculatorMessages = definition.messages;
export const defaultCalculatorMessages = definition.defaultMessages;
export type CalculatorMessages = typeof definition.defaultMessages;
